import React, { FunctionComponent } from 'react';

import { SvgProps, propsHelperRem } from '@/shared/lib/propsHelper';

const DotsHorizontal: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(2.4, 2.4, props)}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 12C7 13.1046 6.10457 14 5 14C3.89543 14 3 13.1046 3 12C3 10.8954 3.89543 10 5 10C6.10457 10 7 10.8954 7 12ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12ZM19 14C20.1046 14 21 13.1046 21 12C21 10.8954 20.1046 10 19 10C17.8954 10 17 10.8954 17 12C17 13.1046 17.8954 14 19 14Z"
        />
    </svg>
);

export default DotsHorizontal;
